export interface FireworkCue {
  at: number;
  x: number;
  y: number;
  z: number;
  palette: number;
  shape: "peony" | "ring" | "willow" | "crown";
  life: number;
  power: number;
}

// Seconds, not normalized fractions: both rendering backends and sound follow
// the same score. Three acts, with breathing room between the early shells.
export const fireworkScore: readonly FireworkCue[] = [
  // Opening: let each colour have its own moment.
  { at: 1.55, x: -0.95, y: 0.55, z: -0.4, palette: 0, shape: "peony", life: 2.7, power: 0.8 },
  { at: 3.25, x: 1.25, y: 0.95, z: -0.9, palette: 1, shape: "crown", life: 2.8, power: 0.85 },
  { at: 4.3, x: -0.3, y: 1.3, z: -1.15, palette: 2, shape: "ring", life: 2.6, power: 0.9 },
  { at: 5.2, x: -1.55, y: 0.85, z: -0.65, palette: 3, shape: "peony", life: 2.6, power: 0.8 },
  { at: 6.1, x: 1.3, y: 0.5, z: -0.3, palette: 4, shape: "crown", life: 2.8, power: 0.9 },
  { at: 6.8, x: -0.45, y: 1.35, z: -1.4, palette: 0, shape: "willow", life: 3.4, power: 0.85 },
  { at: 7.5, x: 1.45, y: 0.9, z: -1.05, palette: 2, shape: "peony", life: 2.5, power: 0.78 },
  // Call and response: alternating heights/depths keep the sky legible.
  { at: 8.15, x: -1.35, y: 0.5, z: -0.25, palette: 1, shape: "crown", life: 2.7, power: 0.85 },
  { at: 8.8, x: 0.5, y: 1.5, z: -1.5, palette: 3, shape: "ring", life: 2.6, power: 0.85 },
  { at: 9.45, x: 1.4, y: 0.55, z: -0.55, palette: 0, shape: "peony", life: 2.7, power: 0.82 },
  { at: 10.1, x: -1.3, y: 1.2, z: -1.1, palette: 2, shape: "crown", life: 2.8, power: 0.88 },
  { at: 10.75, x: 0.15, y: 0.7, z: -0.65, palette: 4, shape: "ring", life: 2.5, power: 0.78 },
  { at: 11.4, x: 1.25, y: 1.35, z: -1.35, palette: 3, shape: "peony", life: 2.8, power: 0.9 },
  { at: 12.05, x: -1.55, y: 0.65, z: -0.45, palette: 0, shape: "crown", life: 2.8, power: 0.88 },
  { at: 12.7, x: 0.3, y: 1.55, z: -1.55, palette: 1, shape: "willow", life: 3.4, power: 0.9 },
  { at: 13.35, x: 1.55, y: 0.8, z: -0.7, palette: 2, shape: "ring", life: 2.6, power: 0.82 },
  { at: 14, x: -1.4, y: 1.3, z: -1.1, palette: 3, shape: "peony", life: 2.7, power: 0.88 },
  { at: 14.65, x: 0.3, y: 0.7, z: -0.35, palette: 4, shape: "crown", life: 2.8, power: 0.95 },
  // Finale: a fuller staggered volley, then a clear fall of gold.
  { at: 15.3, x: -1.6, y: 0.7, z: -0.6, palette: 0, shape: "crown", life: 2.8, power: 0.9 },
  { at: 15.95, x: 1.4, y: 1.15, z: -1.2, palette: 2, shape: "peony", life: 2.7, power: 0.88 },
  { at: 16.6, x: -0.15, y: 1.55, z: -1.55, palette: 3, shape: "crown", life: 2.8, power: 1 },
  { at: 17.05, x: -1.3, y: 0.7, z: -0.55, palette: 1, shape: "peony", life: 2.6, power: 0.8 },
  { at: 17.5, x: 1.5, y: 1, z: -0.95, palette: 4, shape: "ring", life: 2.7, power: 0.9 },
  { at: 18, x: -1.25, y: 0.95, z: -0.7, palette: 4, shape: "willow", life: 3.7, power: 0.95 },
  { at: 18.45, x: 1.25, y: 1.2, z: -1, palette: 0, shape: "willow", life: 3.7, power: 1 },
  { at: 18.85, x: 0, y: 1.5, z: -1.4, palette: 4, shape: "willow", life: 3.7, power: 1.1 },
];

// Rebalance the same particle budget into more independent rays: each shell
// stays as full as the original 15-shell show; mobile allocations do not grow.
export const FIREWORK_TAIL_SAMPLES = 7;

export function crossedBursts(previous: number, elapsed: number) {
  // A resume or seek must never play a backlog of explosions at once.
  if (elapsed <= previous || elapsed - previous > 0.4) return [];
  return fireworkScore.filter(cue => cue.at > previous && cue.at <= elapsed);
}
